import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Axios from "../../lib/Axios";

import JobForm from "./helper/lookingForForm";

const JobPage = () => {
  const [data, setData] = useState([]);
  const [addModal, setAddModal] = useState(false);

  const [filteredData, setFilteredData] = useState(data);
  const [searchTerm, setSearchTerm] = useState("");

  const [editData, setEditData] = useState(null);

  const columns = useMemo(
    () => [
      {
        name: <span className="font-weight-bold fs-13">Looking For</span>,
        selector: (row) => row.lookingFor,
        sortable: true,
      },
      {
        name: <span className="font-weight-bold fs-13">Action</span>,
        sortable: false,

        cell: (props) => {
          return (
            <>
              <div className="d-flex gap-2">
                <div className="edit">
                  <button
                    onClick={() => {
                      setEditData(props);
                      tog_add();
                    }}
                    className="btn btn-sm btn-success edit-item-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#showModal"
                  >
                    Edit
                  </button>
                </div>
                <div className="remove">
                  <Removebtn refetch={fetchList} prop={props} />
                </div>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  function tog_add() {
    setAddModal((prev) => !prev);
  }

  async function fetchList() {
    try {
      const result = await Axios.post("/cms/cms-get/looking-for");
      setData(result?.data?.result?.results);
    } catch (error) {}
  }

  // Filter function
  const handleFilter = (event) => {
    const value = event?.target?.value?.toLowerCase();
    setSearchTerm(value);

    const filtered = data.filter((item) =>
      item.lookingFor.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    fetchList();
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Dashboard" breadcrumbItem="Looking For" />

          <Col lg={12}>
            <Card>
              <CardHeader>
                {/* <h4 className="card-title mb-0">Add, Edit & Remove</h4> */}
              </CardHeader>

              <CardBody>
                <div id="customerList">
                  <Row className="g-4 mb-3">
                    <Col className="col-sm-auto">
                      <div className="d-flex gap-1">
                        <Button
                          color="success"
                          className="add-btn"
                          onClick={() => tog_add()}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add
                        </Button>
                        {/* <Button
                          color="soft-danger"
                          // onClick="deleteMultiple()"
                        >
                          <i className="ri-delete-bin-2-line"></i>
                        </Button> */}
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <div className="search-box ms-2">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleFilter}
                          />
                          {/* <i className="ri-search-line search-icon"></i> */}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <DataTable columns={columns} data={filteredData} pagination />
                </div>
              </CardBody>
            </Card>
          </Col>
          {/* <DataTable columns={columns} data={data} pagination /> */}
        </Container>
      </div>

      <Modal
        isOpen={addModal}
        toggle={() => {
          tog_add();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_add();
          }}
        >
          {" "}
          {editData ? "Edit" : "Add"} Looking for{" "}
        </ModalHeader>
        <JobForm
          setEditData={setEditData}
          data={editData}
          refetch={fetchList}
        />
      </Modal>
    </React.Fragment>
  );
};

function Removebtn({ prop, refetch }) {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const data = {
    LookingFor: [
      {lookingFor:prop.lookingForId,
        lookingForId: prop.lookingForId,
      },
    ],
  };

  async function deleteRecord() {
    try {
      setIsLoading(true);
      const resp = await Axios.post("/cms/cms-delete/looking-for", data);
      refetch();
      tog_delete();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  function tog_delete() {
    setDeleteModal((prev) => !prev);
  }

  return (
    <>
      <button
        disabled={isLoading}
        onClick={tog_delete}
        className="btn btn-sm btn-danger remove-item-btn"
        data-bs-toggle="modal"
        data-bs-target="#deleteRecordModal"
      >
        Remove
      </button>

      <Modal
        isOpen={deleteModal}
        toggle={() => {
          tog_delete();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
          toggle={() => {
            tog_delete();
          }}
        >
          {" "}
          Delete Looking For{" "}
        </ModalHeader>
        <form className="tablelist-form">
          <ModalBody>
            <div className="mt-2 text-center">
              <lord-icon
                src="https://cdn.lordicon.com/gsqxdxog.json"
                trigger="loop"
                colors="primary:#f7b84b,secondary:#f06548"
                style={{ width: "100px", height: "100px" }}
              ></lord-icon>
              <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                <h4>Are you Sure ?</h4>
                <p className="text-muted mx-4 mb-0">
                  Are you Sure You want to Remove this Record ?
                </p>
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button
                type="button"
                className="btn w-sm btn-light"
                onClick={tog_delete}
              >
                Close
              </button>
              <button
                type="button"
                className="btn w-sm btn-danger "
                id="delete-record"
                onClick={deleteRecord}
              >
                Yes, Delete It!
              </button>
            </div>
          </ModalBody>
        </form>
      </Modal>
    </>
  );
}

export default JobPage;
